<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && onSubmit()" novalidate>

  <div class="form-group">
    <label>Email</label>
    <input type="email" name="EMAIL" class="form-control rounded-0" [(ngModel)]="user.EMAIL" #EMAIL="ngModel"
           [ngClass]="{ 'is-invalid': f.submitted && EMAIL.invalid }" required>
    <div *ngIf="f.submitted && EMAIL.invalid" class="invalid-feedback">
      <div *ngIf="EMAIL.errors.required">Email is required</div>
    </div>
  </div>


  <div class="actions horizontal wrap right">
    <button type="button" class="btn btn-rbv default" (click)="actionCancel()">Cancel</button>
    <button type="submit" class="btn btn-rbv">Submit</button>
  </div>

</form>
